<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">This is dedicated to Jon Richards and Claudia Jessup, with thanks and love. The bears are for them.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1b47d880